// QueryForm.js
import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Alert,
  Snackbar,
} from '@mui/material';
import {
  Send as SendIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';
import api from '../../services/api';
import { useModal } from '../../contexts/ModalContext';

const QueryForm = ({ 
  open = false, 
  onClose, 
  queryType = 'UG',
}) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  console.log("queryType", queryType);

  const { openSuccessModal, openErrorModal } = useModal();
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!content.trim()) {
      openErrorModal(
        "Failed to submit query",
        "Please enter your query before submitting"
      );
      return;
    }

    setLoading(true);
    
    try {
      // API call to submit query using api service
      const response = await api.post('customer-query/', {
        query_type: queryType,
        content: content.trim()
      });
      
      

      console.log('Query submitted successfully:', response.data);
      
      // Reset form
      setContent('');
      
      // Close form first
      if (onClose) {
        onClose();
      }
      
      // Then show success modal after a short delay
      setTimeout(() => {
        openSuccessModal(
          "Query submitted successfully!",
          "We will review and get back to you soon."
        );
      }, 100);
      
    } catch (error) {
      console.error('Error submitting query:', error);
      openErrorModal(
        "Failed to submit query",
        error.response?.data?.message || error.message || "Please try again or contact support."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setContent('');
    if (onClose) {
      onClose();
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  if (!open) return null;

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1300,
          p: 2
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            handleCancel();
          }
        }}
      >
        <Card 
          sx={{ 
            maxWidth: 600, 
            width: '100%',
            borderRadius: 3,
            boxShadow: 3
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, textAlign: 'center' }}>
                Submit Query
            </Typography>
            
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                multiline
                rows={6}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder={
                    queryType === 'UG' ? "Please describe your upgrade query here..." :
                    queryType === 'AU' ? "Please describe your user slots query here..." :
                    queryType === 'CR' ? "Please describe your credits query here..." :
                    queryType === 'RW' ? "Please describe your subscription renewal query here..." :
                    queryType === 'OT' ? "Please describe your other query here..." :
                    "Please describe your query or question here..."
                }
                variant="outlined"
                sx={{ mb: 3 }}
                disabled={loading}
                inputProps={{
                  maxLength: 1000
                }}
                helperText={`${content.length}/1000 characters`}
              />
              
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<CancelIcon />}
                  onClick={handleCancel}
                  disabled={loading}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<SendIcon />}
                  disabled={loading || !content.trim()}
                  sx={{ minWidth: 120 }}
                >
                  {loading ? 'Submitting...' : "Submit"}
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default QueryForm;